import CmsRoutes, { CMS_BASE_ROUTES } from './CmsRoutes';

export { CmsRoutes, CMS_BASE_ROUTES };
